import { generateTypes, getCollectionActionHandlers } from 'helpers/actions'

const modelName = 'category'
const modelPlural = 'categories'

export function get () {
  return {
    types: generateTypes(modelPlural),
    api: api => api(modelPlural)
  }
}

export const actions = {
  get
}

// Action Handlers
const initialState = []
const ACTION_HANDLERS = getCollectionActionHandlers({ modelName, modelPlural, tempId: 'name' })

export default function (state = initialState, action) {
  let handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/Categories/modules/categories.js